/* eslint-disable react/prop-types */
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";
import tableStyle from "../../theme/styles/table";
import Button from "../common/Button";
import { style } from "./styles";

function GohonzonApproval({ member, onMemberSelect, onRejectApplication }) {
  const { memberDetails } = member;
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {memberDetails.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.regionName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {member.submittedBy || "-"}
        <br />
        {/* {member.submittedAt !== null
          ? moment(member.submittedAt).format("L")
          : "-"} */}
        {member.submittedAt
          ? moment(member.submittedAt).format("DD/MM/YYYY")
          : "-"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <RemoveRedEyeOutlinedIcon
            style={style.icon}
            onClick={() => onMemberSelect(member.memberId, `interview`)}
          />
          <Box style={{ ...style.ActionBtnContainer }}>
            <Button
              onClick={() => onRejectApplication(member)}
              style={{ ...style.actionBtn, width: "80px" }}
              label="CANCEL"
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonApproval;
